import $ from "jquery";
import _ from "lodash";
import ko from "knockout";
import bindingHandlerUtils from "util/bindingHandlerUtils";

//Constants declaration
const EVENT_NAMESPACE = ".tooltip-event";
const CLOSE_EVENT_NAMESPACE = ".tooltip-close-event";
const LSTRING = "lString";
const SHOW_DELAY = 100; // ms
const TOOLTIP_CONTAINER_CLASS = "tooltip";
const TOOLTIP_INNER_CLASS = "tooltip-inner";
const TOOLTIP_INDICATOR_CLASS = "tooltip-indicator";
const TT_CONTAINER_NAME = "tooltip-container-binding";
const SETTIMEOUT_BINDING_NAME = "tooltip-settimeout-binding";
const SHOW_CLASS = "tooltip-is-open";
const COMPONENT_SUFFIX = "-component";

const TOOLTIP_ARROW_UP = "tooltip-arrow-up";
const TOOLTIP_ARROW_DOWN = "tooltip-arrow-down";

const TOOLTIP_TAIL_CLASS = "tooltip-arrow";
const TOOLTIP_TAIL_RIGHT_POS = "tooltip-tail-right";
const TOOLTIP_TAIL_LEFT_POS = "tooltip-tail-left";

const TOOLTIP_HEADER = "tooltip-header";
const TOOLTIP_CLOSE_BUTTON = "tooltip-close-button";
const SELF_DISMISS_DEFAULT = true; //Default behavior for tooltip: true will self-dismiss tooltip by default;
const IGNORE_CLICK = false; //Default behavior for tooltip: open/close tooltip on click;
const DISPLAY_ON_TRUNCATE_ONLY_DEFAULT = false; //disables rendering of tooltip unless associated content is truncated

/**
 * Hides the tooltip container
 * @param tooltipIndicator
 */
const hideTooltip = function (tooltipIndicator) {
    const tooltipContainer = getTooltipContainer(tooltipIndicator);
    if (tooltipContainer) {
        $(tooltipContainer).removeClass(SHOW_CLASS);
    }
};

/**
 * Shows the tooltip container
 * @param tooltipIndicator
 */
const showTooltip = function (tooltipIndicator) {
    const tooltipContainer = getTooltipContainer(tooltipIndicator);
    if (tooltipContainer) {
        $(tooltipContainer).addClass(SHOW_CLASS);
        return tooltipContainer;
    }
};

/**
 * Handler for closing a tooltip. It verifies conditions to close the tooltip when event is thrown.
 * If the click event is thrown on a node inside of the tooltip container - the tooltip will not close.
 * @param event - click event
 */
const HandleCloseTooltipFromDocument = function (event) {
    const target = event.target;
    const relatedTarget = event?.relatedTarget;

    const tooltipContainer = event?.data?.tooltipContainer;
    const tooltipIndicator = event?.data?.tooltipIndicator;

    const $closeBtn = $("." + TOOLTIP_CLOSE_BUTTON, tooltipContainer);

    const eventFromOutsideOfTooltipContainer = tooltipContainer
        ? !$.contains(tooltipContainer, target)
        : true;

    const eventIsFromCloseButton =
        $closeBtn.length > 0 ? $.contains($closeBtn[0], target) : false;

    if (event?.type === "mouseleave" && relatedTarget) {
        const isMouseOnTooltipContainer =
            tooltipContainer?.contains(relatedTarget);
        const isMouseOnTooltipIndicator =
            tooltipIndicator?.contains(relatedTarget);

        // skip closing tooltip, if the mouse is moved between tooltip indicator & container.
        if (isMouseOnTooltipIndicator || isMouseOnTooltipContainer) {
            if (isMouseOnTooltipContainer) {
                $(tooltipContainer).one(
                    "mouseleave" + EVENT_NAMESPACE + CLOSE_EVENT_NAMESPACE,
                    {
                        tooltipIndicator: tooltipIndicator,
                        tooltipContainer: tooltipContainer,
                    },
                    HandleCloseTooltipFromDocument
                );
            }
            return;
        } else {
            closeTooltip(tooltipIndicator);
        }
    } else if (eventFromOutsideOfTooltipContainer || eventIsFromCloseButton) {
        if (eventIsFromCloseButton) {
            event.preventDefault();
        }
        closeTooltip(tooltipIndicator);
    }
};

/***
 * Returns the tooltip (tooltip container)
 * @param tooltipIndicator
 * @returns node
 */
const getTooltipContainer = function (tooltipIndicator) {
    return ko.utils.domData.get(tooltipIndicator, TT_CONTAINER_NAME);
};

/**
 * Calls openTooltip with a delay
 * @param e - Mouseover
 */
const delayOpenTooltip = function (e) {
    const tooltipIndicator = e.currentTarget;
    clearTooltipOpenTimeout(tooltipIndicator);
    const showDelayHandle = setTimeout(function () {
        openTooltip(tooltipIndicator, e.data);
    }, SHOW_DELAY);
    ko.utils.domData.set(
        tooltipIndicator,
        SETTIMEOUT_BINDING_NAME,
        showDelayHandle
    );
    const options = { showSetTimeOutHandle: showDelayHandle };
    $(tooltipIndicator).one("blur" + EVENT_NAMESPACE, options, cancelTimeOut);
    $(tooltipIndicator).one(
        "mouseleave" + EVENT_NAMESPACE,
        options,
        cancelTimeOut
    );
};

const clearTooltipOpenTimeout = function (tooltipIndicator) {
    const showDelayHandle = ko.utils.domData.get(
        tooltipIndicator,
        SETTIMEOUT_BINDING_NAME
    );
    clearTimeout(showDelayHandle);
};

/***
 * Cancels the openTooltip invocation
 * @param e
 */
const cancelTimeOut = function (e) {
    const showDelayHandle = e.data.showSetTimeOutHandle;
    clearTimeout(showDelayHandle);
};

/**
 * Verifies if the tooltip is currently opened or closed
 * @param tooltipIndicator
 * @returns {boolean}
 */
const isTooltipOpen = function (tooltipIndicator) {
    const tooltipContainer = getTooltipContainer(tooltipIndicator);
    return tooltipContainer && $(tooltipContainer).hasClass(SHOW_CLASS);
};

/**
 * Handles what action to take when the tooltip indicator is clicked on
 * If the tooltip is open then close it
 * If the tooltip is closed then open it.
 * @param event
 */
const handleClickOnTTIndicator = function (event) {
    const tooltipIndicator = event.currentTarget;
    openTooltip(tooltipIndicator, event.data);
};

/**
 * Closes other tooltips except for tooltipIndicator
 * @param tooltipIndicator - tooltip to leave open
 */
const closeOtherTooltips = function (tooltipIndicator) {
    const tooltipArray = $("." + TOOLTIP_INDICATOR_CLASS);
    _.each(tooltipArray, function (tooltip) {
        if (tooltipIndicator !== tooltip) {
            closeTooltip(tooltip);
        }
    });
};

/**
 * Closes the tooltip by hiding it.
 * @param tooltipIndicator - tooltip to close
 */
const closeTooltip = function (tooltipIndicator) {
    if (isTooltipOpen(tooltipIndicator)) {
        hideTooltip(tooltipIndicator);
        $(tooltipIndicator).removeClass(
            TOOLTIP_ARROW_UP + " " + TOOLTIP_ARROW_DOWN
        );
        removeTooltip(tooltipIndicator);
        $("body").off(EVENT_NAMESPACE);
        $(tooltipIndicator).off(CLOSE_EVENT_NAMESPACE);
        $(document).off(CLOSE_EVENT_NAMESPACE);
    }
};
/**
 * Remove the tooltip div container
 * @param  tooltipIndicator
 */
const removeTooltip = function (tooltipIndicator) {
    const tooltipContainer = getTooltipContainer(tooltipIndicator);
    if (tooltipContainer) {
        $(tooltipContainer).remove();
        ko.utils.domData.set(tooltipIndicator, TT_CONTAINER_NAME, null);
    }
};

/**
 * Will add the close button
 * @param tooltipIndicator
 */
const addCloseButton = function (tooltipIndicator) {
    const tooltipContainer = getTooltipContainer(tooltipIndicator);
    const $tooltipContainer = $(tooltipContainer);
    const closeBtn = document.createElement("div");
    const $closeBtn = $(closeBtn);
    $closeBtn.addClass(TOOLTIP_HEADER);
    const closeLabel = ko.i18n.renderString("tooltip.close.button");
    $closeBtn.html(
        '<button class="tooltip-close-button close ns-btn-close"><i class="fa fa-fw fa-times-circle"></i> <span class="sr-only">' +
            closeLabel +
            "</span></button>"
    );
    $tooltipContainer.prepend($closeBtn);
};

/**
 * Displays the tooltip when invoked. Gets triggered by user hovering or clicking on the tooltip Indicator.
 * @param tooltipIndicator - tooltip indicator where the event originated from
 * @param option - the options that were set in initializeTooltip
 */
const openTooltip = function (tooltipIndicator, option) {
    const truncated =
        tooltipIndicator.scrollWidth > tooltipIndicator.clientWidth ||
        tooltipIndicator.scrollHeight > tooltipIndicator.clientHeight;

    // dont show the tooltip when text isn't truncated
    // and the associated element is configured not to
    // show tooltips when no truncation has occurred
    if (!!option.displayOnTruncateOnly && !truncated) {
        return;
    }

    if (typeof option.enable !== "undefined" && !ko.unwrap(option.enable)) {
        return;
    }

    if (!isTooltipOpen(tooltipIndicator)) {
        //Get options
        const placement = option.placement;
        const selfDismiss = option.selfDismiss;

        closeOtherTooltips(tooltipIndicator);
        clearTooltipOpenTimeout(tooltipIndicator);

        const _showTooltip = function (nodes) {
            let tooltipContainer;
            if (nodes) {
                const node = nodes[0];
                tooltipContainer = node.parentNode.parentNode;
                ko.utils.domData.set(
                    tooltipIndicator,
                    TT_CONTAINER_NAME,
                    tooltipContainer
                );
                if (!selfDismiss) {
                    addCloseButton(tooltipIndicator);
                }
            }

            //Position Tooltip
            positionTooltip(tooltipIndicator, placement);

            //show tooltip and setup Events
            tooltipContainer = showTooltip(tooltipIndicator);

            _.defer(function () {
                $("body").on(
                    "click" + EVENT_NAMESPACE,
                    {
                        tooltipIndicator: tooltipIndicator,
                        tooltipContainer: tooltipContainer,
                    },
                    HandleCloseTooltipFromDocument
                );
                $(window).one(
                    "resize" + EVENT_NAMESPACE,
                    {
                        tooltipIndicator: tooltipIndicator,
                        tooltipContainer: tooltipContainer,
                    },
                    HandleCloseTooltipFromDocument
                );
                $(window).one(
                    "scroll" + EVENT_NAMESPACE,
                    {
                        tooltipIndicator: tooltipIndicator,
                        tooltipContainer: tooltipContainer,
                    },
                    HandleCloseTooltipFromDocument
                );
                $(tooltipIndicator)
                    .parents()
                    .one(
                        "scroll" + EVENT_NAMESPACE,
                        {
                            tooltipIndicator: tooltipIndicator,
                            tooltipContainer: tooltipContainer,
                        },
                        HandleCloseTooltipFromDocument
                    );

                $(document).on(
                    "keydown" + EVENT_NAMESPACE + CLOSE_EVENT_NAMESPACE,
                    {
                        tooltipIndicator: tooltipIndicator,
                        tooltipContainer: tooltipContainer,
                    },
                    function (event) {
                        if (
                            event.key === "Escape" &&
                            isTooltipOpen(tooltipIndicator)
                        ) {
                            HandleCloseTooltipFromDocument(event);
                        }
                    }
                );

                if (selfDismiss) {
                    $(tooltipIndicator).on(
                        "mouseleave" + EVENT_NAMESPACE + CLOSE_EVENT_NAMESPACE,
                        {
                            tooltipIndicator: tooltipIndicator,
                            tooltipContainer: tooltipContainer,
                        },
                        HandleCloseTooltipFromDocument
                    );
                    $(tooltipIndicator).on(
                        "blur" + EVENT_NAMESPACE + CLOSE_EVENT_NAMESPACE,
                        {
                            tooltipIndicator: tooltipIndicator,
                            tooltipContainer: tooltipContainer,
                        },
                        HandleCloseTooltipFromDocument
                    );
                } else {
                    $("." + TOOLTIP_CLOSE_BUTTON, tooltipContainer).one(
                        "click" + EVENT_NAMESPACE,
                        {
                            tooltipIndicator: tooltipIndicator,
                            tooltipContainer: tooltipContainer,
                        },
                        HandleCloseTooltipFromDocument
                    );
                }
            });
        };

        createTooltip(tooltipIndicator, option, _showTooltip);
    }
};

/**
 * Creates a tooltip and renders it for the first time.
 * @param tooltipIndicator
 * @param option
 * @param afterRender - typically _showTooltip
 */
const createTooltip = function (tooltipIndicator, option, afterRender) {
    const content = option.content;
    const template = option.template;
    const bindingArgs = option.options;
    const cssClass = option.cssClass ? option.cssClass : "";
    const data = option.viewModel;
    const text = option.text;
    const html = option.html;
    const valueAccessor = ko.unwrap(bindingArgs[1]);
    // prevents previous calls to create the same tooltip from building up tooltips that cannot be removed.
    removeTooltip(tooltipIndicator);

    //Create tooltip Container
    const tooltipContainer = document.createElement("div");
    const $tooltipContainer = $(tooltipContainer);
    $tooltipContainer.addClass(TOOLTIP_CONTAINER_CLASS + " " + cssClass);
    $tooltipContainer.attr("role", "tooltip");

    $("body").append(tooltipContainer);

    // Setting this now so that the dom disposal has a chance to remove it if the
    // indicator is removed before the tolltip is rendered
    ko.utils.domData.set(tooltipIndicator, TT_CONTAINER_NAME, tooltipContainer);

    //Create tooltip inner
    const tooltipInnerDiv = document.createElement("div");
    $(tooltipInnerDiv).addClass(TOOLTIP_INNER_CLASS);
    $tooltipContainer.append(tooltipInnerDiv);

    //Create tooltip tail
    //Add tooltipTail
    const tailDiv = document.createElement("div");
    $(tailDiv).addClass(TOOLTIP_TAIL_CLASS);
    $tooltipContainer.append(tailDiv);

    //Now let's get the content of the tooltip
    if (content) {
        renderlStringInTooltip(
            tooltipInnerDiv,
            content,
            valueAccessor,
            bindingArgs,
            afterRender
        );
    } else if (template) {
        renderTemplateInTooltip(tooltipInnerDiv, template, data, afterRender);
    } else if (text) {
        renderTextInTooltip(tooltipInnerDiv, text, afterRender);
    } else if (html) {
        renderHtmlInTooltip(tooltipInnerDiv, html, afterRender);
    }
};

/**
 * Delegates to the lString Binding to render in the tooltip
 * @param tooltipDiv
 * @param content
 * @param valueAccessor
 * @param afterRender
 */
const renderlStringInTooltip = function (
    tooltipDiv,
    content,
    valueAccessor,
    bindingArgs,
    afterRender
) {
    $(tooltipDiv).html(content);
    const messageKey =
        typeof valueAccessor === "function"
            ? valueAccessor().messageKey
            : valueAccessor.messageKey;
    valueAccessor = function () {
        return {
            data: {},
            name: messageKey,
        };
    };
    const allBindingsAccessor = bindingArgs[2];
    const viewModel = bindingArgs[3];
    ko.bindingHandlers.lString.update(
        tooltipDiv.firstChild,
        valueAccessor,
        allBindingsAccessor,
        viewModel
    );
    afterRender($(tooltipDiv.firstChild)); //passing in child of tooltip container
};

/**
 * Renders template inside of the tooltip
 * @param tooltipDiv - tooltip container node
 * @param template - String for  template location and name
 * @param data - viewModel Object
 * @param afterRender - callback function after rendering the template
 */
const renderTemplateInTooltip = function (
    tooltipDiv,
    template,
    data,
    afterRender
) {
    ko.renderTemplate(
        `templates/${template}`,
        data,
        { afterRender: afterRender },
        tooltipDiv,
        "replaceChildren"
    );
};

/**
 * Renders non localized text in the tooltip
 * @param tooltipDiv - tooltip container node
 * @param text - String to be rendered
 * @param afterRender - callback function
 */

const renderTextInTooltip = function (tooltipDiv, text, afterRender) {
    // text instead of html to avoid script injection
    $(tooltipDiv).text(text);
    afterRender($(tooltipDiv.firstChild));
};

/**
 * Renders html in the tooltip
 * @param tooltipDiv - tooltip container node
 * @param html - HTML to be rendered
 * @param afterRender - callback function
 */
const renderHtmlInTooltip = function (tooltipDiv, html, afterRender) {
    $(tooltipDiv).html(html);
    afterRender($(tooltipDiv.firstChild));
};

/**
 * Cleanup method for when the element's DOM is removed.
 */
const onDisposal = function (element) {
    // clean up events
    cleanupNodeEvent($(element));
    clearTooltipOpenTimeout(element);
    //remove tooltip containers from body
    const tooltipContainer = getTooltipContainer(element);
    if (tooltipContainer) {
        $(tooltipContainer).remove();
    }
};

const cleanupNodeEvent = function ($element) {
    $element.off(EVENT_NAMESPACE);
    $(document).off(CLOSE_EVENT_NAMESPACE);
};

/**
 * Gets the size of padding-left and border-left for the tooltipIndicator
 * @param $tooltipIndicator
 * @returns {*} - integer - Sum of padding Left and Border Left of the tooltipIndicator
 */
const getIndicatorLeftWhiteSpace = function ($tooltipIndicator) {
    let paddingLeft = parseInt($tooltipIndicator.css("padding-left"), 10);
    paddingLeft = isNaN(paddingLeft) ? 0 : paddingLeft;

    let borderLeft = parseInt($tooltipIndicator.css("border-left"), 10);
    borderLeft = isNaN(borderLeft) ? 0 : borderLeft;

    return paddingLeft + borderLeft;
};
/**
 * This function gets the left object for the spaceAroundTTIndicator object created in the
 * positionTooltip function.
 * @param $tooltipIndicator
 */
const getLeftSpaceAroundTTIndicator = function ($tooltipIndicator) {
    const tooltipIndicatorPaddingBorderSpace =
        getIndicatorLeftWhiteSpace($tooltipIndicator);
    const spaceLeft =
        $tooltipIndicator.offset().left + tooltipIndicatorPaddingBorderSpace;
    const visItemContent = $tooltipIndicator
        .closest(".vis-item-content")
        .get(0);
    if (!visItemContent) {
        // used to calculate left space for Participant information tooltip
        return (
            spaceLeft +
            ($tooltipIndicator.outerWidth() -
                tooltipIndicatorPaddingBorderSpace) /
                2
        );
    }
    const $visItemContent = $(visItemContent);
    const visGroup = $tooltipIndicator.closest(".vis-group").get(0);
    const $visGroup = $(visGroup);

    // Fetch css TranslateX value from transform property for visItemContent element
    const contentStyle = window.getComputedStyle(visItemContent);
    const transformMatrix = new DOMMatrix(contentStyle.transform);
    const translateXValue = transformMatrix.m41;

    if (parseInt(translateXValue)) {
        if (
            $visItemContent.outerWidth() - parseInt(translateXValue) >
            $visGroup.outerWidth()
        ) {
            return $tooltipIndicator.offset().left + $visGroup.outerWidth() / 2;
        } else {
            return (
                $tooltipIndicator.offset().left +
                ($tooltipIndicator.outerWidth() - parseInt(translateXValue)) / 2
            );
        }
    }
    if (
        $visItemContent.offset().left + $visItemContent.outerWidth() >
        $visGroup.offset().left + $visGroup.outerWidth()
    ) {
        return (
            ($visItemContent.offset().left +
                $visGroup.offset().left +
                $visGroup.outerWidth()) /
            2
        );
    }
    return (
        spaceLeft +
        ($tooltipIndicator.outerWidth() - tooltipIndicatorPaddingBorderSpace) /
            2
    );
};

/***
 * This function will position the tooltip near the tooltip indicator
 * It detects the best placement for the tooltip container unless specified by the user
 * @param tooltipIndicator - node for the tooltip indicator
 * @param location - String indicating where to place the tooltip
 */
const positionTooltip = function (tooltipIndicator, location) {
    const $tooltipIndicator = $(tooltipIndicator);
    const $tooltipContainer = $(getTooltipContainer(tooltipIndicator));

    const tooltipIndicatorOffSet = $tooltipIndicator.offset();
    const $parentContainer = $(window);

    const spaceTop = tooltipIndicatorOffSet.top;
    const tooltipIndicatorPaddingBorderSpace =
        getIndicatorLeftWhiteSpace($tooltipIndicator);
    const spaceLeft =
        tooltipIndicatorOffSet.left + tooltipIndicatorPaddingBorderSpace;
    const spaceAroundTTIndicator = {
        top: spaceTop + $tooltipIndicator.outerHeight() / 2, //Space on top of indicator from middle of the indicator up of parent container
        left: getLeftSpaceAroundTTIndicator($tooltipIndicator), //Space to the left of indicator from middle of the indicator to the left border of parent container
        right: $parentContainer.outerWidth() - spaceLeft, //Space to the bottom of the indicator from center of indicator to the bottom of window
    };

    const placement = location
        ? getUserPlacement(location)
        : getAutoPlacement(spaceAroundTTIndicator, $tooltipContainer);

    if (placement[0] === "top" && placement[1] === "left") {
        positionTopLeft(
            $tooltipContainer,
            $tooltipIndicator,
            spaceTop,
            spaceAroundTTIndicator
        );
    } else if (placement[0] === "top" && placement[1] === "right") {
        positionTopRight(
            $tooltipContainer,
            $tooltipIndicator,
            spaceTop,
            spaceAroundTTIndicator
        );
    }

    if (placement[0] === "bottom" && placement[1] === "left") {
        positionBottomLeft(
            $tooltipContainer,
            $tooltipIndicator,
            spaceTop,
            spaceAroundTTIndicator
        );
    } else if (placement[0] === "bottom" && placement[1] === "right") {
        positionBottomRight(
            $tooltipContainer,
            $tooltipIndicator,
            spaceTop,
            spaceAroundTTIndicator
        );
    }
};

/**
 * Positions the tooltip to the top right of the tooltip indicator
 * @param $tooltipContainer
 * @param $tooltipIndicator
 * @param spaceTop
 * @param spaceAroundTTIndicator
 */
const positionTopLeft = function (
    $tooltipContainer,
    $tooltipIndicator,
    spaceTop,
    spaceAroundTTIndicator
) {
    //Update tooltip tail classes to reflect which way to point
    const $tail = cleanTooltipTailClass($tooltipContainer);
    $tail.addClass(TOOLTIP_ARROW_DOWN);
    const tailMargin = parseInt($tail.css("margin-right"), null);
    const tailBorder = parseInt($tail.css("border-left-width"), null);

    const tooltipContainerOuterWidth = $tooltipContainer.outerWidth();
    const tooltipContainerPadding = parseInt(
        $tooltipContainer.css("padding-right"),
        null
    );

    const tooltipContainerWidth = Math.min(
        spaceAroundTTIndicator.left - 20,
        tooltipContainerOuterWidth
    );
    $tooltipContainer.css({
        "max-width": tooltipContainerWidth,
    });
    const tooltipContainerOuterHeight = $tooltipContainer.outerHeight();

    //Get new top position
    const newTopPosition =
        spaceTop - tooltipContainerOuterHeight - $(window).scrollTop();

    //Get new left position
    let newLeftPosition = spaceAroundTTIndicator.left - tooltipContainerWidth; // Flush right border of tooltipContainer to center of tooltipIndicator
    //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
    newLeftPosition += tooltipContainerPadding + tailMargin + tailBorder;
    $tooltipContainer.css({
        top: newTopPosition,
        left: newLeftPosition,
        height: tooltipContainerOuterHeight,
    });

    //Now move tail to proper vertical position
    const tailAdjust = -tooltipContainerPadding;
    $tail.css("bottom", tailAdjust);

    //Move tail to proper horizontal position
    $tail.addClass(TOOLTIP_TAIL_RIGHT_POS);
};

/**
 * Positions the tooltip to the top right of the tooltip indicator
 * @param $tooltipContainer
 * @param $tooltipIndicator
 * @param spaceTop
 * @param spaceAroundTTIndicator
 */
const positionTopRight = function (
    $tooltipContainer,
    $tooltipIndicator,
    spaceTop,
    spaceAroundTTIndicator
) {
    //Update tooltip tail classes to reflect which way to point
    const $tail = cleanTooltipTailClass($tooltipContainer);
    $tail.addClass(TOOLTIP_ARROW_DOWN);
    const tailMargin = parseInt($tail.css("margin-right"), null);
    const tailBorder = parseInt($tail.css("border-left-width"), null);
    const tooltipContainerOuterWidth = $tooltipContainer.outerWidth();
    const tooltipContainerPadding = parseInt(
        $tooltipContainer.css("padding-right"),
        null
    );

    const tooltipContainerWidth = Math.min(
        spaceAroundTTIndicator.right - 20,
        tooltipContainerOuterWidth
    );
    $tooltipContainer.css({
        "max-width": tooltipContainerWidth,
    });

    //Get new top position
    const tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
    const newTopPosition =
        spaceTop - tooltipContainerOuterHeight - $(window).scrollTop();

    //Get new left position
    let newLeftPosition = spaceAroundTTIndicator.left; //Flush left border to middle of tooltipIndicator

    //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
    newLeftPosition -= tooltipContainerPadding + tailMargin + tailBorder;
    $tooltipContainer.css({
        top: newTopPosition,
        left: newLeftPosition,
        height: tooltipContainerOuterHeight,
    });

    //Now move tail to proper vertical position
    const tailAdjust = -tooltipContainerPadding;
    $tail.css("bottom", tailAdjust);

    //Move tail to proper horizontal position
    $tail.addClass(TOOLTIP_TAIL_LEFT_POS);
};

/**
 * Positions the tooltip to the bottom left of the tooltip indicator
 * @param $tooltipContainer
 * @param $tooltipIndicator
 * @param spaceTop
 * @param spaceAroundTTIndicator
 */
const positionBottomLeft = function (
    $tooltipContainer,
    $tooltipIndicator,
    spaceTop,
    spaceAroundTTIndicator
) {
    //Update tooltip tail classes to reflect which way to point
    const $tail = cleanTooltipTailClass($tooltipContainer);
    $tail.addClass(TOOLTIP_ARROW_UP);
    const tailMargin = parseInt($tail.css("margin-right"), null);
    const tailBorder = parseInt($tail.css("border-left-width"), null);

    const tooltipContainerOuterWidth = $tooltipContainer.outerWidth();
    const tooltipContainerPadding = parseInt(
        $tooltipContainer.css("padding-right"),
        null
    );

    const tooltipContainerWidth = Math.min(
        spaceAroundTTIndicator.left - 20,
        tooltipContainerOuterWidth
    );
    $tooltipContainer.css({
        "max-width": tooltipContainerWidth,
    });

    //Get new top position
    const newTopPosition =
        spaceTop +
        $tooltipIndicator.outerHeight() +
        getTailHeight() -
        $(window).scrollTop();
    const tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
    //Get new left position
    let newLeftPosition = spaceAroundTTIndicator.left - tooltipContainerWidth; //Flush right border of tooltipContainer to center of tooltipIndicator

    //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
    newLeftPosition += tooltipContainerPadding + tailMargin + tailBorder;
    $tooltipContainer.css({
        top: newTopPosition,
        left: newLeftPosition,
        height: tooltipContainerOuterHeight,
    });

    //Move tail to proper vertical position
    const tailAdjust = tooltipContainerOuterHeight - 1;
    $tail.css("bottom", tailAdjust);

    //Move tail to proper horizontal position
    $tail.addClass(TOOLTIP_TAIL_RIGHT_POS);
};

/**
 * Positions the tooltip to the bottom right of the tooltip indicator
 * @param $tooltipContainer
 * @param $tooltipIndicator
 * @param spaceTop
 * @param spaceAroundTTIndicator
 */
const positionBottomRight = function (
    $tooltipContainer,
    $tooltipIndicator,
    spaceTop,
    spaceAroundTTIndicator
) {
    //Update tooltip tail classes to reflect which way to point
    const $tail = cleanTooltipTailClass($tooltipContainer);
    $tail.addClass(TOOLTIP_ARROW_UP);
    const tailMargin = parseInt($tail.css("margin-right"), null);
    const tailBorder = parseInt($tail.css("border-left-width"), null);

    const tooltipContainerOuterWidth = $tooltipContainer.outerWidth();
    const tooltipContainerPadding = parseInt(
        $tooltipContainer.css("padding-right"),
        null
    );
    const tooltipContainerWidth = Math.min(
        spaceAroundTTIndicator.right - 20,
        tooltipContainerOuterWidth
    );
    $tooltipContainer.css({
        "max-width": tooltipContainerWidth,
    });

    //Get new top position
    const newTopPosition =
        spaceTop +
        $tooltipIndicator.outerHeight() +
        getTailHeight() -
        $(window).scrollTop();
    const tooltipContainerOuterHeight = $tooltipContainer.outerHeight();
    //Get new left position
    let newLeftPosition = spaceAroundTTIndicator.left; //Flush left border to middle of tooltipIndicator

    //Move tooltipContainer to vertically align the center of the tooltipTail to center of tooltipIndicator
    newLeftPosition -= tooltipContainerPadding + tailMargin + tailBorder;
    $tooltipContainer.css({
        top: newTopPosition,
        left: newLeftPosition,
        height: tooltipContainerOuterHeight,
    });

    //Move tail to proper vertical position
    const tailAdjust = tooltipContainerOuterHeight - 1;
    $tail.css("bottom", tailAdjust);

    //Move tail to proper horizontal position
    $tail.addClass(TOOLTIP_TAIL_LEFT_POS);
};

/**
 * returns the height of the tooltip tail
 */
const getTailHeight = function () {
    return parseInt($("." + TOOLTIP_TAIL_CLASS).css("border-left-width"), null);
};

/**
 * Removes unwanted classed from the tooltip tail and returns the tooltip tail element under the tooltipContainer
 * @param $tooltipContainer
 * @returns {*|HTMLElement}
 */
const cleanTooltipTailClass = function ($tooltipContainer) {
    const $tooltipTail = $("." + TOOLTIP_TAIL_CLASS, $tooltipContainer[0]);
    $tooltipTail.removeClass(
        TOOLTIP_ARROW_UP +
            " " +
            TOOLTIP_ARROW_DOWN +
            " " +
            TOOLTIP_TAIL_RIGHT_POS +
            " " +
            TOOLTIP_TAIL_LEFT_POS
    );
    return $tooltipTail;
};

/**
 * Determines placement of tooltip (topleft topright bottomleft bottomright)
 * @param space is object containing measurement around the tooltip indicator {left:xxx, top:xxx, top:xxx, bottom:xxx}
 * @param $tooltipContainer
 * @returns {Array} will return array with first entry as horizontal positioning (top / bottom) and second entry with vertical positioning  (left / right)
 */
const getAutoPlacement = function (spaceAroundTTIndicator, $tooltipContainer) {
    const placement = [];
    placement.push(
        spaceAroundTTIndicator.top >
            $tooltipContainer.outerHeight() + getTailHeight()
            ? "top"
            : "bottom"
    );
    //UX wants priority to the right
    if (spaceAroundTTIndicator.right > $tooltipContainer.outerWidth()) {
        placement.push("right");
    } else if (spaceAroundTTIndicator.left > $tooltipContainer.outerWidth()) {
        placement.push("left");
    } else if (spaceAroundTTIndicator.right > spaceAroundTTIndicator.left) {
        placement.push("right");
    } else {
        placement.push("left");
    }
    return placement;
};

/**
 * Gets user placement
 * @param placement
 */
const getUserPlacement = function (placement) {
    const result = [];
    if (placement.indexOf("top") >= 0) {
        result.push("top");
    } else if (placement.indexOf("bottom") >= 0) {
        result.push("bottom");
    }

    if (placement.indexOf("left") >= 0) {
        result.push("left");
    } else if (placement.indexOf("right") >= 0) {
        result.push("right");
    }
    return result;
};

/**
 * Creates the Aria-label text for the object that reveals the tooltip
 * @param parentText The text from the object that reveals the tooltip
 * @param tooltipText The text from the tooltip
 */
const createAriaLabelText = function (parentText, tooltipText) {
    if (tooltipText) {
        let ariaText = tooltipText;
        if (_.isFunction(ariaText)) {
            ariaText = "" + ariaText();
        }
        return ariaText;
    }
    return parentText.trim();
};

/**
 * Creates the Aria-label callback function to set the attribute using jQuery attr()
 * @param tooltipText The text from the tooltip
 */
const createAriaLabel = function (tooltipText) {
    return function (index, aria_label) {
        if (aria_label) {
            return aria_label;
        }
        const parentText = $(this).text();
        return createAriaLabelText(parentText, tooltipText);
    };
};

const initializeTooltip = function ($element, valueAccessor, componentContext) {
    let options;

    $element.addClass(TOOLTIP_INDICATOR_CLASS);

    if (typeof valueAccessor === "string") {
        options = {
            text: valueAccessor,
            placement: null,
            options: arguments,
            cssClass: null,
            selfDismiss: SELF_DISMISS_DEFAULT,
            ignoreClick: IGNORE_CLICK,
            displayOnTruncateOnly: DISPLAY_ON_TRUNCATE_ONLY_DEFAULT,
        };
    } else {
        const messageKey = valueAccessor.messageKey;
        const template = valueAccessor.template;
        let cssClass = valueAccessor.cssClass;
        const selfDismiss = _.has(valueAccessor, "selfDismiss")
            ? valueAccessor.selfDismiss
            : SELF_DISMISS_DEFAULT;
        const ignoreClick = _.has(valueAccessor, "ignoreClick")
            ? valueAccessor.ignoreClick
            : IGNORE_CLICK;
        const displayOnTruncateOnly = _.has(
            valueAccessor,
            "displayOnTruncateOnly"
        )
            ? valueAccessor.displayOnTruncateOnly
            : DISPLAY_ON_TRUNCATE_ONLY_DEFAULT;
        const data = valueAccessor.data;
        const placement = valueAccessor.placement;
        const text = ko.unwrap(valueAccessor.text);
        const html = ko.unwrap(valueAccessor.html);
        const enable = valueAccessor.enable;
        let content;

        // Pull in the styling from the loading component (So they don't have to wrap the tooltip content with <div class="myComponent-component></div>)
        if (componentContext) {
            cssClass += " " + componentContext + COMPONENT_SUFFIX;
        }

        const commonOptions = {
            placement,
            cssClass,
            selfDismiss,
            ignoreClick,
            displayOnTruncateOnly,
            enable,
            options: arguments,
        };

        if (typeof messageKey === "string") {
            const bindString =
                'data-bind="' + LSTRING + ":'" + messageKey + "'\"";
            content = "<div " + bindString + "></div>";
            options = { content, ...commonOptions };
        } else if (template) {
            options = { template, viewModel: data, ...commonOptions };
        } else if (text) {
            options = { text, ...commonOptions };
        } else if (html) {
            options = { html, ...commonOptions };
        }
    }

    //Set Events and aria-label
    if (options) {
        if (!options.ignoreClick) {
            $element.on(
                "dblclick" + EVENT_NAMESPACE,
                options,
                delayOpenTooltip
            );
            $element.on(
                "click" + EVENT_NAMESPACE,
                options,
                handleClickOnTTIndicator
            );
        }
        $element.on("focus" + EVENT_NAMESPACE, options, delayOpenTooltip);
        $element.on("mouseover" + EVENT_NAMESPACE, options, delayOpenTooltip);
        if (!options.displayOnTruncateOnly) {
            $element.attr("aria-label", createAriaLabel(options.text));
        }
    }
};

/**
 *  <p>Tooltip Binding Handler</p>
 *
 *  This binding will create a tooltip on the binding element.
 *  Example of binding syntax and properties:
 *
 *  1) data-bind = "tooltip: {text: 'This is tooltip content'}  - short hand: data-bind = "tooltip:'This is tooltip content'"
 *     Where text contains the non localized string that is displayed in the tooltip
 *
 *  OR
 *
 *  2) data-bind = "tooltip: {messageKey:'config.error.400', data:$data}" token replacement is done against data object
 *     Where messageKey is used as in the lString data-bind. Tooltip content is thus defined in the json local file ex: en-US.json
 *     and data is the viewModel object that will bind to the template. data is optional and may be omitted
 *
 *  OR
 *
 *  3) data-bind = "tooltip: {template: 'templates/help/sampleTooltipHelp', data:$data}"
 *     Where template is the name of the template to include in the tooltip
 *     and data is the viewModel object that will bind to the template. data is optional and may be omitted
 *
 *  With any of the example above you can also specify the following optional properties
 *
 *      placement: top,left / top,right / bottom,left / bottom, right
 *        for example:  data-bind = "tooltip: {text: "This is tooltip content", placement:"top,left"}
 *
 *      cssClass:  "class1 class2 class3"   These css classes will be added to the tooltip container
 *
 *      ignoreClick: true - will ignore tooltip click actions when user clicks the element (default is false - process click normally)
 *
 *      selfDismiss: true  - will default to true  - Self-dismisses the tooltip on mouseleave from the tooltip indicator
 *          for example: data-bind = "tooltip: {text: "This is tooltip content", selfDismiss: "true"}
 *
 *
 */
ko.bindingHandlers.tooltip = {
    init: function (
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext
    ) {
        const value = ko.unwrap(valueAccessor());
        if (value) {
            const $element = $(element);

            if (value.template) {
                value.template =
                    bindingHandlerUtils.adjustTemplateNameForContext(
                        value.template,
                        bindingContext
                    );
            }
            const componentContext =
                bindingHandlerUtils.getContext(bindingContext);

            initializeTooltip($element, value, componentContext);

            // Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(
                element,
                onDisposal.bind(null, element)
            );
        }
    },

    update: function (
        element,
        valueAccessor,
        allBindings,
        viewModel,
        bindingContext
    ) {
        const value = ko.unwrap(valueAccessor());
        if (value) {
            if (value.template) {
                value.template =
                    bindingHandlerUtils.adjustTemplateNameForContext(
                        value.template,
                        bindingContext
                    );
            }
            const componentContext =
                bindingHandlerUtils.getContext(bindingContext);

            const $element = $(element);
            removeTooltip(element);
            cleanupNodeEvent($element);
            initializeTooltip($element, value, componentContext);
        }
    },
};
